export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      screenIdMsts: [
        {
          screenIdMstUuid: 'screenidmst001',
          screenId: 'BUSCF00015',
          screenName: '設定画面（トップ）',
          serviceTypes: [
            {
              serviceTypeCd: 1,
              serviceTypeName: 'コミュニティサポート系'
            },
            {
              serviceTypeCd: 2,
              serviceTypeName: 'hoam系'
            },
            {
              serviceTypeCd: 3,
              serviceTypeName: "マンション・ホテル系",
            },
            {
              serviceTypeCd: 4,
              serviceTypeName: "directサイネージ系",
            }
          ],
          screenTransitionFlg: true,
          screenIdStatus: 1,
        },
        {
          screenIdMstUuid: 'screenidmst002',
          screenId: 'BUSCF00025',
          screenName: 'ビューワーモード画面',
          serviceTypes: [
            {
              serviceTypeCd: 1,
              serviceTypeName: 'コミュニティサポート系'
            },
            {
              serviceTypeCd: 3,
              serviceTypeName: "マンション・ホテル系",
            },
            {
              serviceTypeCd: 4,
              serviceTypeName: "directサイネージ系",
            }
          ],
          screenTransitionFlg: true,
          screenIdStatus: 1,
        },
        {
          screenIdMstUuid: 'screenidmst003',
          screenId: 'BUSCF00026',
          screenName: 'スクリーンセーバー画面',
          serviceTypes: [
            {
              serviceTypeCd: 2,
              serviceTypeName: 'hoam系'
            }
          ],
          screenTransitionFlg: false,
          screenIdStatus: 1,
        },
        {
          screenIdMstUuid: 'screenidmst004',
          screenId: 'BUSCF00029',
          screenName: 'ライブカメラ画面',
          serviceTypes: [
            {
              serviceTypeCd: 3,
              serviceTypeName: "マンション・ホテル系",
            }
          ],
          screenTransitionFlg: false,
          screenIdStatus: 1,
        },
        {
          screenIdMstUuid: 'screenidmst005',
          screenId: 'BUSCF00033',
          screenName: '消灯画面',
          serviceTypes: [
            {
              serviceTypeCd: 2,
              serviceTypeName: 'hoam系'
            },
            {
              serviceTypeCd: 3,
              serviceTypeName: "マンション・ホテル系",
            }
          ],
          screenTransitionFlg: true,
          screenIdStatus: 1,
        }
      ]
    }
  }
}